export const EMOJIS = [
  // caras
  {
    emoji: require("@/assets/images/emoji/U1F44F.png"),
    code: "U+1F44F",
    whitSound: true,
  },
  {
    emoji: require("@/assets/images/emoji/U1F941.png"),
    code: "U+1F941",
    whitSound: true,
  },
  {
    emoji: require("@/assets/images/emoji/U1F921.png"),
    code: "U+1F921",
    whitSound: true,
  },
  {
    emoji: require("@/assets/images/emoji/U1F602.png"),
    code: "U+1F602",
  },
  {
    emoji: require("@/assets/images/emoji/U1F605.png"),
    code: "U+1F605",
  },
  {
    emoji: require("@/assets/images/emoji/U1F609.png"),
    code: "U+1F609",
  },
  {
    emoji: require("@/assets/images/emoji/U1F618.png"),
    code: "U+1F618",
  },
  {
    emoji: require("@/assets/images/emoji/U1F44B.png"),
    code: "U+1F44B",
  },
  {
    emoji: require("@/assets/images/emoji/U1F631.png"),
    code: "U+1F631",
    whitSound: true,
  },
  {
    emoji: require("@/assets/images/emoji/U1F634.png"),
    code: "U+1F634",
  },
  {
    emoji: require("@/assets/images/emoji/U1F912.png"),
    code: "U+1F912",
  },
  {
    emoji: require("@/assets/images/emoji/U1F913.png"),
    code: "U+1F913",
  },
  {
    emoji: require("@/assets/images/emoji/U1F923.png"),
    code: "U+1F923",
  },
  {
    emoji: require("@/assets/images/emoji/U1F60A.png"),
    code: "U+1F60A",
  },
  {
    emoji: require("@/assets/images/emoji/U1F60D.png"),
    code: "U+1F60D",
  },
  {
    emoji: require("@/assets/images/emoji/U1F61C.png"),
    code: "U+1F61C",
  },
  {
    emoji: require("@/assets/images/emoji/U1F62C.png"),
    code: "U+1F62C",
  },
  {
    emoji: require("@/assets/images/emoji/U1F62D.png"),
    code: "U+1F62D",
  },
  {
    emoji: require("@/assets/images/emoji/U1F480.png"),
    code: "U+1F480",
  },
  {
    emoji: require("@/assets/images/emoji/U1F608.png"),
    code: "U+1F608",
  },
  {
    emoji: require("@/assets/images/emoji/U1F47F.png"),
    code: "U+1F47F",
  },
  {
    emoji: require("@/assets/images/emoji/U1F916.png"),
    code: "U+1F916",
  },
  {
    emoji: require("@/assets/images/emoji/U1F47B.png"),
    code: "U+1F47B",
  },
  {
    emoji: require("@/assets/images/emoji/U1F47D.png"),
    code: "U+1F47D",
  },
  {
    emoji: require("@/assets/images/emoji/U1F4A9.png"),
    code: "U+1F4A9",
  },
  // manos

  {
    emoji: require("@/assets/images/emoji/U270C.png"),
    code: "U+270C",
  },
  {
    emoji: require("@/assets/images/emoji/U1F44C.png"),
    code: "U+1F44C",
  },
  {
    emoji: require("@/assets/images/emoji/U1F4AA.png"),
    code: "U+1F4AA",
  },
  {
    emoji: require("@/assets/images/emoji/U1F64F.png"),
    code: "U+1F64F",
  },
  {
    emoji: require("@/assets/images/emoji/U1F91D.png"),
    code: "U+1F91D",
  },
  {
    emoji: require("@/assets/images/emoji/U1F919.png"),
    code: "U+1F919",
  },
  {
    emoji: require("@/assets/images/emoji/U1F91F.png"),
    code: "U+1F91F",
  },
  {
    emoji: require("@/assets/images/emoji/U1F595.png"),
    code: "U+1F595",
  },
  // comida
  {
    emoji: require("@/assets/images/emoji/U2615.png"),
    code: "U+2615",
  },
  {
    emoji: require("@/assets/images/emoji/U1F346.png"),
    code: "U+1F346",
  },
  {
    emoji: require("@/assets/images/emoji/U1F32F.png"),
    code: "U+1F32F",
  },
  {
    emoji: require("@/assets/images/emoji/U1F37A.png"),
    code: "U+1F37A",
  },
  {
    emoji: require("@/assets/images/emoji/U1F354.png"),
    code: "U+1F354",
  },
  {
    emoji: require("@/assets/images/emoji/U1F355.png"),
    code: "U+1F355",
  },
  {
    emoji: require("@/assets/images/emoji/U1F363.png"),
    code: "U+1F363",
  },
  {
    emoji: require("@/assets/images/emoji/U1F375.png"),
    code: "U+1F375",
  },
  {
    emoji: require("@/assets/images/emoji/U1F382.png"),
    code: "U+1F382",
  },
  {
    emoji: require("@/assets/images/emoji/U1F950.png"),
    code: "U+1F950",
  },
  {
    emoji: require("@/assets/images/emoji/U1F957.png"),
    code: "U+1F957",
  },
  {
    emoji: require("@/assets/images/emoji/U1F958.png"),
    code: "U+1F958",
  },
  // animales
  {
    emoji: require("@/assets/images/emoji/U1F64A.png"),
    code: "U+1F64A",
  },
  {
    emoji: require("@/assets/images/emoji/U1F648.png"),
    code: "U+1F648",
  },
  {
    emoji: require("@/assets/images/emoji/U1F649.png"),
    code: "U+1F649",
  },
  {
    emoji: require("@/assets/images/emoji/U1F423.png"),
    code: "U+1F423",
  },
  {
    emoji: require("@/assets/images/emoji/U1F425.png"),
    code: "U+1F425",
  },
  {
    emoji: require("@/assets/images/emoji/U1F431.png"),
    code: "U+1F431",
  },
  {
    emoji: require("@/assets/images/emoji/U1F436.png"),
    code: "U+1F436",
  },
  {
    emoji: require("@/assets/images/emoji/U1F437.png"),
    code: "U+1F437",
  },
  {
    emoji: require("@/assets/images/emoji/U1F438.png"),
    code: "U+1F438",
  },
  {
    emoji: require("@/assets/images/emoji/U1F42D.png"),
    code: "U+1F42D",
  },
  {
    emoji: require("@/assets/images/emoji/U1F98A.png"),
    code: "U+1F98A",
  },
  {
    emoji: require("@/assets/images/emoji/U1F981.png"),
    code: "U+1F981",
  },
  {
    emoji: require("@/assets/images/emoji/U1F983.png"),
    code: "U+1F983",
  },
  // deportes
  {
    emoji: require("@/assets/images/emoji/U1F423.png"),
    code: "U+1F423",
  },
  // deportes
  {
    emoji: require("@/assets/images/emoji/U26BD.png"),
    code: "U+26BD",
  },
  {
    emoji: require("@/assets/images/emoji/U26BE.png"),
    code: "U+26BE",
  },
  {
    emoji: require("@/assets/images/emoji/U1F3C8.png"),
    code: "U+1F3C8",
  },
  {
    emoji: require("@/assets/images/emoji/U1F3C0.png"),
    code: "U+1F3C0",
  },
  {
    emoji: require("@/assets/images/emoji/U1F94E.png"),
    code: "U+1F94E",
  },
  {
    emoji: require("@/assets/images/emoji/U1F3C6.png"),
    code: "U+1F3C6",
  },
  // clima
  {
    emoji: require("@/assets/images/emoji/U1F31E.png"),
    code: "U+1F31E",
  },
  {
    emoji: require("@/assets/images/emoji/U26F1.png"),
    code: "U+26F1",
  },
  {
    emoji: require("@/assets/images/emoji/U1F308.png"),
    code: "U+1F308",
  },
  {
    emoji: require("@/assets/images/emoji/U1F327.png"),
    code: "U+1F327",
  },
  {
    emoji: require("@/assets/images/emoji/U1F328.png"),
    code: "U+1F328",
  },
  {
    emoji: require("@/assets/images/emoji/U2601.png"),
    code: "U+2601",
  },
  // fiestas
  {
    emoji: require("@/assets/images/emoji/U1F383.png"),
    code: "U+1F383",
  },
  {
    emoji: require("@/assets/images/emoji/U1F384.png"),
    code: "U+1F384",
  },
  {
    emoji: require("@/assets/images/emoji/U1F385.png"),
    code: "U+1F385",
  },
  {
    emoji: require("@/assets/images/emoji/U1F389.png"),
    code: "U+1F389",
  },
  {
    emoji: require("@/assets/images/emoji/U1F340.png"),
    code: "U+1F340",
  },
  // misc
  {
    emoji: require("@/assets/images/emoji/U2764.png"),
    code: "U+2764",
  },
  {
    emoji: require("@/assets/images/emoji/U2B50.png"),
    code: "U+2B50",
  },
  {
    emoji: require("@/assets/images/emoji/U1F3B5.png"),
    code: "U+1F3B5",
  },
  {
    emoji: require("@/assets/images/emoji/U1F576.png"),
    code: "U+1F576",
  },
  {
    emoji: require("@/assets/images/emoji/U1F514.png"),
    code: "U+1F514",
  },
  {
    emoji: require("@/assets/images/emoji/U1F525.png"),
    code: "U+1F525",
  },
  {
    emoji: require("@/assets/images/emoji/U1F399.png"),
    code: "U+1F399",
  },
  {
    emoji: require("@/assets/images/emoji/U1F579.png"),
    code: "U+1F579",
  },
  {
    emoji: require("@/assets/images/emoji/U1F4E2.png"),
    code: "U+1F4E2",
  },
  {
    emoji: require("@/assets/images/emoji/U1F4DE.png"),
    code: "U+1F4DE",
  },
  {
    emoji: require("@/assets/images/emoji/U1F6AB.png"),
    code: "U+1F6AB",
  },
  {
    emoji: require("@/assets/images/emoji/U267B.png"),
    code: "U+267B",
  },
];
